import type * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';

export type SuggestedTitle_Movie_Fragment = {
	__typename: 'Movie';
	id: string;
	objectType: Types.ObjectType;
	objectId: number;
	content: {
		__typename?: 'MovieContent';
		fullPath: string;
		title: string;
		originalReleaseYear?: number | null;
		posterUrl?: string | null;
	};
	watchNowOffer?: {
		__typename?: 'Offer';
		id: string;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			shortName: string;
		};
	} | null;
	offers: Array<{
		__typename?: 'Offer';
		monetizationType: Types.MonetizationType;
		presentationType: Types.PresentationType;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		id: string;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			shortName: string;
		};
	}>;
};

export type SuggestedTitle_Show_Fragment = {
	__typename: 'Show';
	id: string;
	objectType: Types.ObjectType;
	objectId: number;
	content: {
		__typename?: 'ShowContent';
		fullPath: string;
		title: string;
		originalReleaseYear?: number | null;
		posterUrl?: string | null;
	};
	watchNowOffer?: {
		__typename?: 'Offer';
		id: string;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			shortName: string;
		};
	} | null;
	offers: Array<{
		__typename?: 'Offer';
		monetizationType: Types.MonetizationType;
		presentationType: Types.PresentationType;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		id: string;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			shortName: string;
		};
	}>;
};

export type SuggestedTitleFragment = SuggestedTitle_Movie_Fragment | SuggestedTitle_Show_Fragment;

export const SuggestedTitleFragmentDoc = gql`
    fragment SuggestedTitle on MovieOrShow {
  __typename
  id
  objectType
  objectId
  content(country: $country, language: $language) {
    fullPath
    title
    originalReleaseYear
    posterUrl
    fullPath
  }
  watchNowOffer(country: $country, platform: WEB) {
    id
    standardWebURL
    preAffiliatedStandardWebURL
    package {
      id
      packageId
      shortName
    }
  }
  offers(country: $country, platform: WEB, filter: {preAffiliate: true}) {
    monetizationType
    presentationType
    standardWebURL
    preAffiliatedStandardWebURL
    package {
      id
      packageId
      shortName
    }
    id
  }
}
    `;
